import { AdminSmartListFunctionGetDto } from "@common/dto/admin-function/get";
import { HttpSuccessDto } from "@common/dto/http";
import { clientTransformed } from "@common/utils/rest";
import {UserPermissions} from "@common/dto/user/permissions";

export const getAdminSmartListFunctions = (): Promise<AdminSmartListFunctionGetDto> => {
  return clientTransformed({
    path: 'api/smartListAdmin/adminFunctionsList',
    method: 'GET',
  }).then((response: HttpSuccessDto<AdminSmartListFunctionGetDto>) => {
    return  response.entity;
  });
};

export const getUserPermissions = (): Promise<UserPermissions> => {
  return clientTransformed({
    path: 'api/permissions',
    method: 'GET',
  }).then((response: HttpSuccessDto<UserPermissions>) => {
    return response.entity;
  });
};